import { Injectable } from '@angular/core';
import { CanActivate, NavigationEnd, Router } from '@angular/router';
import { ArianeeService } from '../../providers/arianee-service/arianee.service';
import { filter, first, take } from 'rxjs/operators';
import { MyCertificatesService } from '../../providers/my-certificates/my-certificates.service';
import { PoapService } from '../../providers/poap/poap.service';

@Injectable({
  providedIn: 'root'
})
export class IsMonoBrand implements CanActivate {
  private previousUrl: string = '';

  constructor (
    private router: Router,
    private arianeejsService: ArianeeService,
    private myCertificatesService: MyCertificatesService,
    private poapService: PoapService
  ) {
    router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.previousUrl = event.url;
      });
  }

  private getIssuerAddresses = async (): Promise<string[]> => {
    const certificates = await this.myCertificatesService
      .getAllMyCertificatesGroupedByIssuer()
      .pipe(take(1))
      .toPromise();

    return Object.keys(certificates || {});
  }

  private redirectTo (urlTree:string) {
    return this.router.createUrlTree([urlTree]);
  }

  public poapListUrlTree=() => 'tab/brand-list/poap-nft-list';
  public issuerBrandListUrlTree=(issuerAddress:string) => `tab/brand-product-list/${issuerAddress}`;

  public findIssuerAddressIfMonobrandRedirection = async (): Promise<string | undefined> => {
    const poaps = await this.poapService.getMyPoapNfts().pipe(first()).toPromise();
    const issuers = await this.getIssuerAddresses();
    const firstIssuer = issuers[0];
    const isOnlyOneBrand = issuers.length === 1;
    const hasArianeeNFT = issuers.length > 0;
    const hasPoap = poaps.length > 0;
    const hasPoapAndArianeeNft = hasPoap && hasArianeeNFT;

    if (hasPoapAndArianeeNft) {
      return undefined;
    }

    if (hasArianeeNFT && isOnlyOneBrand && firstIssuer) {
      return this.issuerBrandListUrlTree(firstIssuer);
    }
    if (hasPoap) {
      return this.poapListUrlTree();
    }
  };

  public canActivate = async (): Promise<any> => {
    const urlTreeRedirection = await this.findIssuerAddressIfMonobrandRedirection();

    if (urlTreeRedirection) {
      return this.redirectTo(urlTreeRedirection);
    } else {
      return true;
    }
  }
}
